// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductProperties_summary-container__YwcSW {
  max-width: 300px;
  min-width: 276px;
  height: -moz-fit-content;
  height: fit-content;
}
.ProductProperties_summary-container__YwcSW .ProductProperties_summary-title__-X4sY {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.ProductProperties_summary-container__YwcSW .ProductProperties_summary-title-red__KxgXG {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #ffc0bd;
}
.ProductProperties_summary-container__YwcSW .ProductProperties_summary-message-red__wYaHL {
  font-weight: bold;
  color: #c9423c;
  margin-bottom: 10px;
}
.ProductProperties_summary-container__YwcSW .ProductProperties_summary-characteristic-red__S18nF {
  color: #ffc0bd;
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/ProductProperties/ProductProperties.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EAqBE,gBAAA;EACA,gBAAA;EACA,wBAAA;EAAA,mBAAA;AAtBF;AAAE;EACE,eCDO;EDEP,iBCCG;EDAH,mBAAA;AAEJ;AAAE;EACE,eCNO;EDOP,iBCJG;EDKH,mBAAA;EACA,cAAA;AAEJ;AAAE;EACE,iBCTG;EDUH,cAAA;EACA,mBAAA;AAEJ;AAAE;EACE,cAAA;AAEJ","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.summary-container {\n  .summary-title {\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n    margin-bottom: 10px;\n  }\n  .summary-title-red {\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n    margin-bottom: 10px;\n    color: #ffc0bd;\n  }\n  .summary-message-red {\n    font-weight: typography.$bold;\n    color: #c9423c;\n    margin-bottom: 10px;\n  }\n  .summary-characteristic-red {\n    color: #ffc0bd;\n  }\n\n  max-width: 300px;\n  min-width: 276px;\n  height: fit-content;\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summary-container": `ProductProperties_summary-container__YwcSW`,
	"summary-title": `ProductProperties_summary-title__-X4sY`,
	"summary-title-red": `ProductProperties_summary-title-red__KxgXG`,
	"summary-message-red": `ProductProperties_summary-message-red__wYaHL`,
	"summary-characteristic-red": `ProductProperties_summary-characteristic-red__S18nF`
};
export default ___CSS_LOADER_EXPORT___;
